jQuery(($) => {
  $(document.body).on('updated_cart_totals wc_cart_emptied', () => {
    // move the message correctly into its wrapper
    $('.woocommerce-message, .woocommerce-info, .woocommerce-error').appendTo(
      $('.woocommerce-notices-wrapper .container > div')
    );

    $('#cart-total').html('...');

    /**
     * Update cart item count.
     */
    $.ajax({
      url: bb_global_params.admin_ajax_url,
      data: {
        action: 'bb_get_cart_contents_count',
      },
      dataType: 'json',
      success: (json) => {
        // `json.value` comes as a string!
        if (json.value == 0) {
          $('#header .cart').removeClass('has-items');
        }
        $('#cart-total').html(json.value);
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        // once it updates, renable checkoutBtn
        enableCheckoutButton(true);
        // ...
        listenToQuantityInputs();
      },
    });

    /**
     * Update prebuilt cart sharer.
     */
    $.ajax({
      url: bb_global_params.admin_ajax_url,
      data: {
        action: 'bb_get_prebuilt_cart_sharer_template',
      },
      timeout: 54000,
      dataType: 'json',
      success: (data) => {
        $('.prebuilt-cart-sharer-wrapper').html(data.html);
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        console.log('complete');
      },
    });
  });

  const listenToQuantityInputs = () => {
    $('.cart_item input.qty').on('input', () => {
      enableCheckoutButton(false);
    });
  };

  listenToQuantityInputs();

  const enableCheckoutButton = (enable) => {
    var checkoutBtn = $('.cart-collaterals .proceed-to-checkout-button');
    if (enable) {
      checkoutBtn.removeClass('disabled');
    } else {
      checkoutBtn.addClass('disabled');
    }
  };
});
